/* Pasted layout JSON (DOM-free, unit-tested): accept a layout doc, a
   {name, doc} record, an array of either, or a starter-layouts file, and
   hand back named docs ready for normalizeDoc. */
export interface Pasted { name: string | null; doc: Record<string, unknown> }

const isDoc = (v: unknown): v is Record<string, unknown> => !!v && typeof v === 'object' && Array.isArray((v as { walls?: unknown }).walls);

export function parsePasted(text: string): Pasted[] | null {
  let v: unknown;
  try { v = JSON.parse(text.trim().replace(/^```(?:json)?\s*|\s*```$/g, '')); } catch { return null; }   // tolerate a fenced code block
  const one = (x: unknown): Pasted | null => {
    if (isDoc(x)) return { name: typeof (x as { name?: unknown }).name === 'string' ? String((x as { name: string }).name) : null, doc: x };
    if (x && typeof x === 'object' && isDoc((x as { doc?: unknown }).doc))
      return { name: typeof (x as { name?: unknown }).name === 'string' ? (x as { name: string }).name : null, doc: (x as { doc: Record<string, unknown> }).doc };
    return null;
  };
  const list = (Array.isArray(v) ? v : [v]).map(one).filter((p): p is Pasted => !!p);
  return list.length ? list : null;
}

/** A safe layout name: trimmed, no slashes, not empty, unique against `taken`. */
export function layoutName(wanted: string | null, fallback: string, taken: Set<string>): string {
  let base = (wanted || fallback).replace(/[\/\\]/g, '-').trim().slice(0, 60) || fallback;
  let name = base, i = 2;
  while (taken.has(name)) name = `${base} ${i++}`;
  return name;
}
